//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { FindShow, FindPrev, FindNext } from "./js/find.js";
export default {
  props: {
    vScope: {
      dom: ""
    }
  },
  data: function data() {
    return {
      keyword: "",
      scope: {
        dom: "",
        msg: "已经是最后一个！",
        callback: this.fnVFindCallback
      }
    };
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      Object.assign(this.scope, this.vScope);
    },
    // 搜索显示匹配项
    fnFindjs: function fnFindjs(ev) {
      if (ev.keyCode === 13 && this.keyword) {
        if (!this.vScope.dom) {
          this.vScope.dom = "";
        }

        FindShow(this.scope);
      } else if (ev.keyCode === 8 && !this.keyword) {
        FindShow(this.scope);
      }
    },
    // 向上搜索
    fnFindPrev: function fnFindPrev() {
      if (!this.vScope.dom) {
        this.vScope.dom = "";
      }

      FindPrev(this.scope);
    },
    // 向下搜索
    fnFindNext: function fnFindNext() {
      if (!this.vScope.dom) {
        this.vScope.dom = "";
      }

      FindNext(this.scope);
    },
    // 搜索组件，提示框
    fnVFindCallback: function fnVFindCallback() {}
  }
};